import { createSelector, IContactUsState, IAttachmentsState } from '../../../../models/reduxState';
import { contactStateSelector } from '../../../app/selectors/contactUsSelector';

export const attachmentsStateSelector = createSelector(contactStateSelector, (r: IContactUsState) => r.AttachmentsState);

export const isAttachmentActionAbortedSelector = createSelector(
    attachmentsStateSelector,
    (r: IAttachmentsState) => r.isAttachmentActionAborted
);

export const isAttachmentActionInProgressSelector = createSelector(
    attachmentsStateSelector,
    (r: IAttachmentsState) => r.isAttachmentsEnabledConsumer
);
